import { Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ItemModule, ViewItem } from '../../appshared/invoice/item/item.module';
import { ActivatedRoute, Router } from '@angular/router';
import { ItemService } from '../../appshared/invoice/item/item.service';
import { AppLoaderService } from '../service/app-loader/app-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { CartService } from '../../appshared/invoice/cart.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
    selector: 'app-offer',
    templateUrl: './offer.component.html',
    styleUrls: ['./offer.component.scss']
})
export class OfferComponent {

    currentDate = new Date();
    sortType: string = "Default";
    Cid: number = 75;
    public SelectedLanguage: string = "en";
    public dataSourceItems = new MatTableDataSource<ItemModule>();
    ComID: number = 2;
    public apiURL: string = "";
    constructor(public router: Router, private route: ActivatedRoute, private servItem: ItemService, private loader: AppLoaderService, public translate: TranslateService, private cartService: CartService, private toastr: ToastrService) { }

    ngOnInit(): void {

        this.apiURL = environment.apiUrl2 + 'Attachment/Companies/' + this.ComID + '/Items/';
        this.fillItems();

        if (this.translate.currentLang != undefined) {
            this.SelectedLanguage = this.translate.currentLang;
        }


        if (this.SelectedLanguage == 'ar') {
            this.slideConfig = {
                ...this.slideConfig,
                rtl: true,
            };

            this.productsSlidesOptions = {
                loop: true,
                nav: false,
                dots: true,
                autoplayHoverPause: true,
                autoplay: true,
                //margin: 10,
                rtl: true,
                navText: [
                    "<i class='bx bx-right-arrow-alt'></i>",
                    "<i class='bx bx-left-arrow-alt'></i>"
                ],
                responsive: {
                    0: {
                        items: 1
                    },
                    576: {
                        items: 2
                    },
                    768: {
                        items: 3
                    },
                    992: {
                        items: 4
                    },
                    1200: {
                        items: 4
                    }
                }
            }
        }
        else {
            this.slideConfig = {
                ...this.slideConfig,
                rtl: false,
            };
        }
    }

    slideConfig = {
        slidesToShow: 6,
        slidesToScroll: 6,
        autoplay: false,
        autoplaySpeed: 3000,
        variableWidth: false, // <— crucial!
        centerMode: false,    // optional: can cause visual offset
        adaptiveHeight: false,
        infinite: true,
        dots: false,
        arrows: true,
        prevArrow: '<button class="slick-prev custom-arrow"><i class="bx bx-chevron-left"></i></button>',
        nextArrow: '<button class="slick-next custom-arrow"><i class="bx bx-chevron-right"></i></button>',
        rtl: false,
        centerPadding: '5px',
        responsive: [
            {
                breakpoint: 1200, // screens below 1200px
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: 850, // screens below 768px
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 650, // even smaller screens
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ]
    };


    fillItems() {
        //    this.loader.open();
        this.servItem.getServiceDiscount(this.ComID)
            .subscribe((res: ItemModule[]) => {
                this.loader.close();

                for (var i = 0; i < res.length; i++) {
                    res[i].webDiscountFromDate = new Date(res[i].webDiscountFromDate);
                    res[i].webDiscountToDate = new Date(res[i].webDiscountToDate);
                }

                this.dataSourceItems.data = res;


            },
                (err: any) => {
                    this.loader.close();
                    console.log(err);
                });
    }




    addToCart(itemM: ItemModule) {

        // var ViewItems = new ViewItem();

        this.loader.open();

        var price = itemM.salesPrice;
        if (itemM.activateWebDiscount && itemM.webDiscountFromDate < new Date() && itemM.webDiscountToDate > new Date()) {
            price = itemM.webDiscountAmount;
        }


        var product: ViewItem = {


            inItemID: itemM.inItemID,
            name: itemM.webNameEn,
            nameAr: itemM.webNameAr,
            salesPrice: itemM.salesPrice,
            barcode: itemM.barcode,
            inCategoryID: itemM.inCategoryID,
            description: itemM.description,
            inUnitID: itemM.inUnitID,
            photoPath: itemM.photoPath,
            itemCode: itemM.itemCode,
            unitName: itemM.unitName,
            systemCode: itemM.systemCode,
            categoryNameAr: itemM.categoryNameAr,
            descriptionAr: itemM.descriptionAr,
            categoryName: itemM.categoryName,

            saleTaxPercentage: itemM.saleTaxPercentage,
            isViewWeb: itemM.isViewWeb,
            webDiscountFromDate: itemM.webDiscountFromDate,
            webDiscountToDate: itemM.webDiscountToDate,
            webDiscountAmount: itemM.webDiscountAmount,
            activateWebDiscount: itemM.activateWebDiscount,
            unitNameAr: itemM.unitNameAr,
            webDiscountPercentage: itemM.webDiscountPercentage,
            wholesalePrice: itemM.webDiscountPercentage,

            cartQuantity: 1,
            cartPrice: price

        };



        this.cartService.addToCart(product, 1);

        this.loader.close();

        var transR = this.translate.instant('Your_product_added_to_the_cart');
        this.toastr.success(transR, '');



        //this.servItem.getItemBranchNoSales(this.ComID, itemM.inItemID, 1)
        //    .subscribe(res => {

        //        this.loader.close();
        //        if (+res >= 1) {



        //            var price = itemM.salesPrice;
        //            if (itemM.activateWebDiscount && itemM.webDiscountFromDate < new Date() && itemM.webDiscountToDate > new Date()) {
        //                price = itemM.webDiscountAmount;
        //            }


        //            var product: ViewItem = {


        //                inItemID: itemM.inItemID,
        //                name: itemM.webNameEn,
        //                nameAr: itemM.webNameAr,
        //                salesPrice: itemM.salesPrice,
        //                barcode: itemM.barcode,
        //                inCategoryID: itemM.inCategoryID,
        //                description: itemM.description,
        //                inUnitID: itemM.inUnitID,
        //                photoPath: itemM.photoPath,
        //                itemCode: itemM.itemCode,
        //                unitName: itemM.unitName,
        //                systemCode: itemM.systemCode,
        //                categoryNameAr: itemM.categoryNameAr,
        //                descriptionAr: itemM.descriptionAr,
        //                categoryName: itemM.categoryName,

        //                saleTaxPercentage: itemM.saleTaxPercentage,
        //                isViewWeb: itemM.isViewWeb,
        //                webDiscountFromDate: itemM.webDiscountFromDate,
        //                webDiscountToDate: itemM.webDiscountToDate,
        //                webDiscountAmount: itemM.webDiscountAmount,
        //                activateWebDiscount: itemM.activateWebDiscount,
        //                unitNameAr: itemM.unitNameAr,
        //                webDiscountPercentage: itemM.webDiscountPercentage,
        //                wholesalePrice: itemM.webDiscountPercentage,

        //                cartQuantity: 1,
        //                cartPrice: price

        //            };



        //            this.cartService.addToCart(product);


        //            var transR = this.translate.instant('Your_product_added_to_the_cart');
        //            this.toastr.success(transR, '');



        //        }
        //        else {

        //            var transR = this.translate.instant('This_Item_Out_of_Stock');
        //            this.toastr.warning(transR, '');
        //        }

        //    },
        //        (err: any) => {
        //            console.log(err);
        //        });
    }


    isShowingMore = false;

    showMore(value: boolean) {
        this.isShowingMore = value;
    }

    get displayedItems() {
        return this.isShowingMore
            ? this.dataSourceItems.data
            : this.dataSourceItems.data.slice(0, 2);
    }


    onClickItem(ItemId: number) {
        this.router.navigate(['product-details', { ItemId: ItemId }]);
    }



    //    productsSlidesOptions: OwlOptions = {
    //        items: 1,
    //        nav: true,
    //        loop: true,
    //        margin: 25,
    //        dots: false,
    //        autoplay: true,
    //        smartSpeed: 1000,
    //        autoplayHoverPause: true,
    //navText: [
    //	"<i class='bx bx-left-arrow-alt'></i>",
    //	"<i class='bx bx-right-arrow-alt'></i>"
    //],
    //        responsive: {
    //            0: {
    //                items: 1
    //            },
    //            414: {
    //                items: 1
    //            },
    //            576: {
    //                items: 2
    //            },
    //            768: {
    //                items: 2
    //            },
    //            992: {
    //                items: 3
    //            },
    //            1200: {
    //                items: 4
    //            }


    //}
    //  }



    productsSlidesOptions: OwlOptions = {
        loop: false,
        nav: false,
        dots: true,
        autoplayHoverPause: true,
        autoplay: true,
        //margin: 10,
        navText: [
            "<i class='bx bx-left-arrow-alt'></i>",
            "<i class='bx bx-right-arrow-alt'></i>"
        ],
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 2
            },
            768: {
                items: 3
            },
            992: {
                items: 4
            },
            1200: {
                items: 4
            }
        }
    }

    onClickNextItem(currentIndex: number) {
        const nextIndex = currentIndex + 1;
        const nextItemId = this.dataSourceItems.data[nextIndex].inItemID;
        this.router.navigate(['product-details', { ItemId: nextItemId }]);
    }
    getNextImage(currentIndex: number): string | null {
        const nextIndex = currentIndex + 1;
        if (nextIndex < this.dataSourceItems.data.length) {
            return this.apiURL + this.dataSourceItems.data[nextIndex].photoPath;
        }
        return null; // No next image
    }

    onClickAfterNextItem(currentIndex: number) {
        const afterNextIndex = currentIndex + 2;
        const AfternextItemId = this.dataSourceItems.data[afterNextIndex].inItemID;
        this.router.navigate(['product-details', { ItemId: AfternextItemId }]);
    }
    getAfterNextImage(currentIndex: number): string | null {
        const afterNextIndex = currentIndex + 2;
        if (afterNextIndex < this.dataSourceItems.data.length) {
            return this.apiURL + this.dataSourceItems.data[afterNextIndex].photoPath;
        }
        return null; // No after next image
    }


    onClickAfterAfterNextItem(currentIndex: number) {
        const afterAfterNextIndex = currentIndex + 3;
        const AfterAfternextItemId = this.dataSourceItems.data[afterAfterNextIndex].inItemID;
        this.router.navigate(['product-details', { ItemId: AfterAfternextItemId }]);
    }
    getAfterAfterNextImage(currentIndex: number): string | null {
        const afterAfterNextIndex = currentIndex + 3;
        if (afterAfterNextIndex < this.dataSourceItems.data.length) {
            return this.apiURL + this.dataSourceItems.data[afterAfterNextIndex].photoPath;
        }
        return null; // No after after next image
    }

    openItems(categoryType: String) {

        this.router.navigate(['items_screen', { Type: categoryType }]);
    }
}
